import { el, editable, input } from './domUtils';

const emptyPath = (variant) => ({ variant, tag: '', title: '', subtitle: '', criteria: [''], time: '' });

export default class DecisionTreeTool {
  static get toolbox() {
    return {
      title: 'Йўлларни танлаш',
      icon: '<svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M6 3v12a3 3 0 003 3h6M6 9h6a3 3 0 003-3V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><circle cx="6" cy="3" r="2" stroke="currentColor" stroke-width="2"/><circle cx="18" cy="3" r="2" stroke="currentColor" stroke-width="2"/><circle cx="9" cy="18" r="2" stroke="currentColor" stroke-width="2"/></svg>',
    };
  }

  static get sanitize() {
    return { title: {}, subtitle: {}, paths: { tag: {}, title: {}, subtitle: {}, criteria: {}, time: {} } };
  }

  constructor({ data }) {
    this.data = {
      title: data.title || '',
      subtitle: data.subtitle || '',
      paths: data.paths?.length ? data.paths : [emptyPath('simple'), emptyPath('complex')],
    };
  }

  render() {
    this.titleEl = input(this.data.title, 'Сарлавҳа: масалан, «Икки йўл бор»');
    this.titleEl.classList.add('at-input-strong');
    this.subtitleEl = input(this.data.subtitle, 'Қисқа изоҳ...');

    this.pathsWrap = el('div', { class: 'at-paths' });
    this.data.paths.forEach((path) => this.addPath(path));

    const addBtn = el('button', { type: 'button', class: 'at-add-btn', onclick: () => this.addPath(emptyPath('simple')) }, ['+ Йўл қўшиш']);

    return el('div', { class: 'at-block at-decision-tree' }, [
      el('div', { class: 'at-block-label' }, ['Йўлларни танлаш']),
      this.titleEl,
      this.subtitleEl,
      this.pathsWrap,
      addBtn,
    ]);
  }

  addPath(path) {
    const variant = el('select', { class: 'at-input at-select' }, [
      el('option', { value: 'simple' }, ['Оддий']),
      el('option', { value: 'complex' }, ['Мураккаб']),
    ]);
    variant.value = path.variant || 'simple';

    const tag = input(path.tag, 'Тег: масалан, «Оддий йўл»');
    const title = input(path.title, 'Йўл сарлавҳаси...');
    title.classList.add('at-input-strong');
    const subtitle = input(path.subtitle, 'Қисқа изоҳ...');
    const time = input(path.time, 'Муддат: масалан, «1-2 ой»');

    const criteriaWrap = el('div', { class: 'at-rows' });
    (path.criteria?.length ? path.criteria : ['']).forEach((c) => this.addCriterion(criteriaWrap, c));
    const addCriterionBtn = el('button', { type: 'button', class: 'at-add-btn-sm', onclick: () => this.addCriterion(criteriaWrap, '') }, ['+ Шарт']);

    const removePathBtn = el('button', { type: 'button', class: 'at-remove-btn-text' }, ['× Йўлни ўчириш']);

    const pathEl = el('div', { class: 'at-path' }, [
      el('div', { class: 'at-row' }, [variant, tag, removePathBtn]),
      title,
      subtitle,
      el('div', { class: 'at-criteria-label' }, ['Шартлар']),
      criteriaWrap,
      addCriterionBtn,
      time,
    ]);
    pathEl._refs = { variant, tag, title, subtitle, time, criteriaWrap };

    removePathBtn.addEventListener('click', () => {
      if (this.pathsWrap.children.length > 1) pathEl.remove();
    });

    this.pathsWrap.appendChild(pathEl);
  }

  addCriterion(wrap, value) {
    const text = editable(value, 'Шарт матни...');
    const removeBtn = el('button', { type: 'button', class: 'at-remove-btn' }, ['×']);
    const row = el('div', { class: 'at-row-item' }, [text, removeBtn]);
    removeBtn.addEventListener('click', () => {
      if (wrap.children.length > 1) row.remove();
    });
    wrap.appendChild(row);
  }

  save() {
    return {
      title: this.titleEl.value.trim(),
      subtitle: this.subtitleEl.value.trim(),
      paths: Array.from(this.pathsWrap.children).map((pathEl) => {
        const { variant, tag, title, subtitle, time, criteriaWrap } = pathEl._refs;
        return {
          variant: variant.value,
          tag: tag.value.trim(),
          title: title.value.trim(),
          subtitle: subtitle.value.trim(),
          time: time.value.trim(),
          criteria: Array.from(criteriaWrap.children)
            .map((row) => row.firstChild.innerHTML.trim())
            .filter(Boolean),
        };
      }),
    };
  }
}
